// Falls back to a same-origin relative path so the bundle never embeds
// an absolute dev URL. For local dev, set REACT_APP_API_BASE_URL in
// frontend/.env (already in place pointing at the local backend).
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/v1';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  ACTIVATE: '/activate',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  PRODUCTS: '/products',
  CART: '/cart',
  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:id',
  INVOICES: '/invoices',
  INVOICE_DETAIL: '/invoices/:invoiceId',
  PROFILE: '/profile',
  NOTIFICATIONS: '/notifications',
  
  // Payment routes
  PAYMENT_SUCCESS: '/payment/success',
  PAYMENT_PENDING: '/payment/pending',
  PAYMENT_ERROR: '/payment/error',
  
  // Admin routes
  ADMIN: '/admin',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_CUSTOMERS: '/admin/customers',
  ADMIN_ORDERS: '/admin/orders',
  ADMIN_PRODUCTS: '/admin/products',
  ADMIN_USERS: '/admin/users',
  ADMIN_SETTINGS: '/admin/settings',
  
  // Backoffice routes
  BACKOFFICE: '/backoffice',
  BACKOFFICE_LOGIN: '/backoffice/login',
  BACKOFFICE_DASHBOARD: '/backoffice/dashboard',
  BACKOFFICE_SIGNUP_REQUESTS: '/backoffice/signup-requests',
  BACKOFFICE_CUSTOMER_MANAGEMENT: '/backoffice/customers',
  BACKOFFICE_ORDER_MANAGEMENT: '/backoffice/orders',
  BACKOFFICE_USER_MANAGEMENT: '/backoffice/users',
  BACKOFFICE_EPICOR_CONNECT: '/backoffice/epicor-connect',
  
  // Notification Management routes
  BACKOFFICE_NOTIFICATION_TEMPLATES: '/backoffice/notifications/templates',
  BACKOFFICE_NOTIFICATION_SETTINGS: '/backoffice/notifications/settings',
  BACKOFFICE_NOTIFICATION_MANAGEMENT: '/backoffice/notifications/management',

  // Product Info Management
  BACKOFFICE_PRODUCT_INFO: '/backoffice/product-info',

  // Promotions Management
  BACKOFFICE_PROMOTIONS: '/backoffice/promotions',
} as const;

export const USER_ROLES = {
  CUSTOMER: 'customer',
  SALES: 'sales',
  FINANCE: 'finance',
  BACKOFFICE: 'backoffice',
  IT_ADMIN: 'it_admin',
} as const;

export const ORDER_STATUS = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  CONFIRMED: 'confirmed',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
} as const;

export const INVOICE_STATUS = {
  OPEN: 'open',
  PAID: 'paid',
  OVERDUE: 'overdue',
  CANCELLED: 'cancelled',
} as const;

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
} as const;

export const SUPPORTED_LANGUAGES = {
  ID: 'id',
  EN: 'en',
} as const;

export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES.ID;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

export const CURRENCY = {
  SYMBOL: 'Rp',
  CODE: 'IDR',
} as const;